import axios from "axios";
import { CurrencyIcon } from "./fixcode";

function createTabStorage(prefix = "tabstore") {
    // let tabId = sessionStorage.getItem("tabId");
    // console.log("tabId===>", tabId)
    // if (!tabId) {
    //     tabId = `tab_${Date.now()}_${Math.random()}`;
    //     sessionStorage.setItem("tabId", tabId);
    // }
    let tabId = window.name || `tab_${Date.now()}_${Math.random()}`;
    window.name = tabId;
    sessionStorage.setItem("tabId", tabId);


    const _getKey = (key) => {
        // console.log(`${prefix}_${tabId}_${key}`, prefix, tabId, key);
        return `${prefix}_${tabId}_${key}`
    };

    // -------------------------------
    // Core methods
    // -------------------------------
    const setItem = async (key, value) => {
        localStorage.setItem(_getKey(key), JSON.stringify(value));
    };

    const getItem = (key) => {
        const value = localStorage.getItem(_getKey(key));
        return value ? JSON.parse(value) : null;
    };

    const removeItem = async (key) => {
        localStorage.removeItem(_getKey(key));
    };

    const clear = async () => {
        Object.keys(localStorage).forEach((k) => {
            if (k.startsWith(`${prefix}_${tabId}_`)) {
                localStorage.removeItem(k);
            }
        });
    };

    // -------------------------------
    // Session helpers
    // -------------------------------
    const setSessionItem = async (key, value) => {
        if (value === undefined || value === null) {
            await removeItem(`session_${key}`);
        } else {
            await setItem(`session_${key}`, value);
        }
    };

    const clearSessionItems = async () => {
        Object.keys(localStorage).forEach((k) => {
            if (k.startsWith(`${prefix}_${tabId}_session_`)) {
                localStorage.removeItem(k);
            }
        });
    };
    const setSecureItem = async (key, value) => {
        secureLocalStorage.setItem(_getKey(key), JSON.stringify(value));
    };

    const getSecureItem = (key) => {
        const value = secureLocalStorage.getItem(_getKey(key));
        return value ? JSON.parse(value) : null;
    };

    // -------------------------------
    // Accessors
    // -------------------------------
    const accessors = {
        isAuthorized: async () => {
            // debugger
            let value = await getItem("session_authorized")
            return value
        },
        sessionId: () => getItem("session_authtoken"),
        userId: () => {
            const val = getItem("session_userid");
            return val !== null ? Number(val) : null;
        },
        user: () => getItem("session_user"),
        userName: () => getItem("session_username"),
        firstName: () => getItem("session_firstname"),
        lastName: () => getItem("session_lastname"),
        password: () => getItem("session_password"),
        userTypeId: () => {
            debugger;
            const val = getItem("session_usertypeid");
            return val !== null ? Number(val) : null;
        },
        userTypeName: () => getItem("session_usertypename"),
        phoneNumber: () => getItem("session_mobile"),
        email: () => getItem("session_email"),
        profilePhotoUrl: () => getItem("session_profilephotourl"),
        companyId: () => {
            const val = getItem("session_companyid");
            return val !== null ? Number(val) : null;
        },
        customerId: () => {
            debugger;
            const val = getItem("session_customerid");
            return val !== null ? Number(val) : null;
        },
        branchId: () => {
            const val = getItem("session_branchid");
            return val !== null ? Number(val) : null;
        },
        branchName: () => getItem("session_branchname"),
        currencyIcon: {
            Normal: () => getItem("session_currencyicon"),
            Xs: () => getItem("session_currencyicon").then((v) => `${v} fa-xs`),
            Sm: () => getItem("session_currencyicon").then((v) => `${v} fa-sm`),
            Lg: () => getItem("session_currencyicon").then((v) => `${v} fa-lg`),
        },
        userFeatureSetup: () => getItem("session_userFeatureSetup"),
        ameyoUserName: () => getItem("session_ameyousername"),
        ameyoPasscode: () => getItem("session_ameyopasscode"),
        ameyoAccess: () => getItem("session_ameyoaccess"),
        trackingGuid: () => getItem("session_trackingguid"),
    };

    // -------------------------------
    // Extra utilities
    // -------------------------------
    const getCurrentLocation = async () => {
        let lat = 0,
            lng = 0,
            ip = "";
        try {
            const curlocation = await axios.get("https://ipapi.co/json");
            if (curlocation?.data) {
                lat = curlocation.data.latitude;
                lng = curlocation.data.longitude;
                ip = curlocation.data.ip;
            }
        } catch (error) {
            console.log(error);
        }
        return { lat, lng, ip };
    };

    const getCurrencyIcon = (currencyCode) => {
        let currencyIcon = CurrencyIcon.ruppesFormat;
        if (currencyCode) {
            switch (currencyCode.toLowerCase()) {
                case "inr":
                    currencyIcon = CurrencyIcon.ruppesFormat;
                    break;
                default:
                    break;
            }
        }
        return currencyIcon;
    };

    return {
        setItem,
        getItem,
        removeItem,
        clear,
        setSessionItem,
        clearSessionItems,
        ...accessors,
        getCurrentLocation,
        getCurrencyIcon,
        setSecureItem,
        getSecureItem,
    };
}

const TabStorage = createTabStorage();
export default TabStorage;
